import { z } from 'zod';
export var ReachFeature;
(function (ReachFeature) {
    ReachFeature["ENGAGE"] = "engage";
    ReachFeature["MEASURE"] = "measure";
    ReachFeature["REPUTATION"] = "reputation";
    ReachFeature["ACQUIRE"] = "acquire";
    ReachFeature["VOICE"] = "voice";
})(ReachFeature || (ReachFeature = {}));
export const REACH_FEATURES = Object.values(ReachFeature);
/**
 * Features that currently support partner-requested cancellation.
 * Expand this tuple (and the controller switch) as each feature gains support.
 */
export const featureCancellationFeatureSchema = z.enum([ReachFeature.VOICE, ReachFeature.ENGAGE]);
export const featureCancellationRequestSchema = z.object({
    feature: featureCancellationFeatureSchema,
});
export const featureCancellationResponseSchema = z.object({
    businessId: z.string(),
    feature: featureCancellationFeatureSchema,
    jobId: z.string().uuid(),
});
//# sourceMappingURL=features.js.map